// reset-password.tsx — 004-dual-login-2fa T026
// Route /reset-password?token=<jwt>
// Accessible sans authentification (lien email). Décision R-04 (research.md).

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ResetPasswordPage } from "@/presentation/pages/ResetPasswordPage";

const searchSchema = z.object({
  token: z.string().min(1),
  email: z.string().email(),
});

interface ResetPasswordSearch {
  token: string;
  email: string;
}

export const Route = createFileRoute("/reset-password")({
  validateSearch: (search: Record<string, unknown>): ResetPasswordSearch => {
    const parsed = searchSchema.safeParse(search);
    return parsed.success ? parsed.data : { token: "", email: "" };
  },
  component: function ResetPasswordRouteComponent() {
    const { token, email } = Route.useSearch();
    return <ResetPasswordPage token={token} email={email} />;
  },
});
